import React, { useState } from "react";
import { Link } from "gatsby";
import Container from "./container";
import ImageG from "./image-g";
import { cn, getUrl } from "../lib/helpers";
import Button from "./button";
import { useGlobalState } from "./global-context";

import * as styles from "../styles/components/fc-applications.module.css";

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface ButtonType {
  blank?: boolean;
  text?: string;
  url?: string;
}

interface Slug {
  current?: string;
}

interface ResponsiveImage {
  desktop?: ImageAsset;
  mobile?: ImageAsset;
}

interface LpSettings {
  image?: ImageAsset;
}

interface Application {
  title?: string;
  slug?: Slug;
  lp?: LpSettings;
}

interface ApplicationItem {
  _key?: string;
  application?: Application;
}

interface ApplicationsProps {
  applications?: ApplicationItem[];
  defaultImage?: ResponsiveImage;
  button?: ButtonType;
}

const Applications: React.FC<ApplicationsProps> = ({
  applications,
  defaultImage,
  button,
}) => {
  const { desktop: desktopImage, mobile: mobileImage } = defaultImage || {};

  if (!applications || applications.length === 0 || !desktopImage?.asset) {
    return null;
  }

  const [showDefaultImage, setShowDefaultImage] = useState<boolean>(true);
  const { isMobile } = useGlobalState();

  const handleLinkMouseEnter = () => {
    setShowDefaultImage(false);
  };

  const handleLinkMouseLeave = () => {
    setShowDefaultImage(true);
  };

  return (
    <div className={styles.root}>
      <Container>
        <div className={styles.inner}>
          <div className={cn(styles.image, !showDefaultImage && styles.hide)}>
            <ImageG node={desktopImage} nodeM={mobileImage} />
          </div>

          <div className={styles.text}>
            <div className={styles.nav}>
              <h2 className={styles.title}>Applications</h2>

              <ul>
                {applications.map(({ _key, application }) => {
                  if (!application.slug || !application.slug.current)
                    return null;

                  return (
                    <li key={_key}>
                      <h3
                        className={styles.itemTitle}
                        onMouseEnter={
                          isMobile ? undefined : handleLinkMouseEnter
                        }
                        onMouseLeave={
                          isMobile ? undefined : handleLinkMouseLeave
                        }
                      >
                        <Link to={getUrl(application.slug, "applications")}>
                          {application.title}
                        </Link>
                      </h3>
                      <div className={styles.image}>
                        <ImageG node={application.lp?.image} />
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <Button node={button} theme="white" />
        </div>
      </Container>
    </div>
  );
};

export default Applications;
